/* ============================================================
   Raíz Viva — Cayena Vital (slug: raizviva)
   Cargado por layout/landing.liquid (case 'raizviva').
   Bloques: galería de thumbnails · carrusel de mini-testimonios ·
   fade-in on scroll · selección de bundle · disparo del modal Releasit COD.

   Patrón Releasit (ver memory/project_bundles_as_variants):
   cada bundle = 1 variante real con precio POR UNIDAD, y se manda la
   cantidad real (1/2/3) en input[name="quantity"] para que
   precio_unitario × quantity = total del bundle Y el pedido llegue a Dropi
   con las unidades físicas correctas.
   NO usar _rsiV2.setState como primer path: solo el click nativo del botón
   Releasit re-lee window.productData después de cambiar la variante.
   ============================================================ */

/* ---------- Galería: el thumbnail cambia la imagen principal ---------- */
(function () {
  var main = document.getElementById('rvMain');
  var thumbs = document.querySelectorAll('.raizviva-landing .rv-thumb');
  if (!main || !thumbs.length) return;
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      var src = t.getAttribute('data-src');
      if (!src) return;
      thumbs.forEach(function (x) { x.classList.remove('rv-on'); });
      t.classList.add('rv-on');
      main.setAttribute('src', src);
    });
  });
})();

window.rvScrollThumbs = function (dir) {
  var track = document.getElementById('rvTrack');
  if (track) track.scrollBy({ left: dir * 200, behavior: 'smooth' });
};

/* ---------- Carrusel de mini-testimonios ---------- */
(function () {
  var slides = document.querySelectorAll('#rvMini .rv-mini-slide');
  var dots = document.querySelectorAll('#rvMini .rv-dot');
  if (!slides.length) return;
  var i = 0;
  function go(n) {
    i = n;
    slides.forEach(function (s) { s.classList.remove('rv-on'); });
    dots.forEach(function (d) { d.classList.remove('rv-on'); });
    if (slides[n]) slides[n].classList.add('rv-on');
    if (dots[n]) dots[n].classList.add('rv-on');
  }
  window.rvMiniGo = go;
  dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
  setInterval(function () { go((i + 1) % slides.length); }, 5000);
})();

/* ---------- Fade-in on scroll ---------- */
(function () {
  var els = document.querySelectorAll('.raizviva-landing .rv-sup');
  if (!els.length) return;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('rv-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('rv-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.2 });
  els.forEach(function (el, n) { el.style.transitionDelay = (n * 0.12) + 's'; io.observe(el); });
})();

/* ============================================================
   Selección de bundle + trigger Releasit COD
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  var selectedVariantId = null;
  var selectedQty = 1;

  // Releasit lee input[name="quantity"] del DOM al disparar el COD
  // (verificado 2026-06-06 capturando el cartLinesAdd del Storefront).
  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (input) {
      input.value = variantId;
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (input) {
      input.value = variantId;
    });
    document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      input.value = String(q);
      input.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  var stickyPrice = document.getElementById('rvStickyPrice');

  function bundleQty(el) {
    var q = parseInt(el.getAttribute('data-bundle-qty'), 10);
    if (!q) {
      var idx = parseInt(el.getAttribute('data-bundle-index'), 10);
      q = isNaN(idx) ? 1 : idx + 1;
    }
    return q || 1;
  }

  var bundles = document.querySelectorAll('.raizviva-landing .rv-bundle[data-bundle-variant-id]');

  function selectBundle(el) {
    var id = el.getAttribute('data-bundle-variant-id');
    if (!id) return;
    bundles.forEach(function (b) { b.classList.remove('rv-sel'); });
    el.classList.add('rv-sel');
    selectedVariantId = id;
    selectedQty = bundleQty(el);
    setVariantOnAllForms(id, selectedQty);
    if (stickyPrice) {
      var now = el.getAttribute('data-price') || '';
      var was = el.getAttribute('data-was') || '';
      stickyPrice.innerHTML = '$' + now + (was ? ' <small>$' + was + '</small>' : '');
    }
  }

  bundles.forEach(function (el) {
    el.addEventListener('click', function () { selectBundle(el); });
  });

  // Init: el bundle marcado activo en el HTML (o el primero)
  (function initSelected() {
    var active = document.querySelector('.raizviva-landing .rv-bundle.rv-sel[data-bundle-variant-id]') || bundles[0];
    if (!active) return;
    selectedVariantId = active.getAttribute('data-bundle-variant-id');
    selectedQty = bundleQty(active);
    setVariantOnAllForms(selectedVariantId, selectedQty);
    if (stickyPrice) {
      var now = active.getAttribute('data-price') || '';
      var was = active.getAttribute('data-was') || '';
      stickyPrice.innerHTML = '$' + now + (was ? ' <small>$' + was + '</small>' : '');
    }
  })();

  window.raizvivaTriggerCOD = function (btn) {
    var variantId = (btn && btn.getAttribute && btn.getAttribute('data-bundle-variant-id')) || selectedVariantId;
    var qty = (btn && btn.getAttribute && btn.getAttribute('data-bundle-qty')) || selectedQty;
    if (variantId) setVariantOnAllForms(variantId, qty);
    setTimeout(function () {
      var releasitBtn = findReleasitButton();
      if (releasitBtn) { releasitBtn.click(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasitButton();
        if (b) { clearInterval(poll); b.click(); return; }
        if (attempts > 30) {
          clearInterval(poll);
          // último recurso: abre el modal con la variante que Releasit cacheó
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
            try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
          }
        }
      }, 100);
    }, 50);
  };
})();
